import HealthPlansCategoriesComponent from 'modules/healthPlans/components/HealthPlansCategoriesComponent';

const HealthPlansCategoriesContainer = () => <HealthPlansCategoriesComponent />;

HealthPlansCategoriesContainer.propTypes = {};

HealthPlansCategoriesContainer.defaultProps = {};

export default HealthPlansCategoriesContainer;
